(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/grassroots-toaster/assets/javascripts/grassroots-toaster.js') >= 0) return;  svs.modules.push('/components/sport/grassroots-toaster/assets/javascripts/grassroots-toaster.js'); 'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

svs.sport = svs.sport || {};

svs.sport.GrassrootsToaster = function () {
  var log = new svs.core.log.Logger('svs.sport.GrassrootsToaster');

  var show = function show(args) {
    var expires = svs.components.Storage.constants.EXPIRES_1MONTH * 60000;
    var dismissed = svs.components.Storage.browser.get('toasterdismissed', 'grassroots');
    var dismissedCount = _typeof(dismissed) === 'object' ? dismissed.count : dismissed + 0 || 0;
    var dismissedTime = _typeof(dismissed) === 'object' ? dismissed.time : 0;
    var askForToaster = dismissedCount === 0 || dismissedCount < 3 && dismissedTime + expires < new Date().getTime();

    if (askForToaster) {
      var dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'favorites',
        autoClose: false,
        area: svs.components.dialog.area.TOASTER,
        title: 'Stötta dina favoritföreningar med Gräsroten',
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: 'Välj upp till tre favoritföreningar som får ditt stöd varje gång du spelar.'
        }],
        actions: [{
          title: dismissedCount >= 2 ? 'Visa inte igen' : 'Påminn mig senare',
          callback: function callback() {
            svs.components.Storage.browser.set('toasterdismissed', 'grassroots', {
              count: dismissedCount + 1,
              time: new Date().getTime()
            }, svs.components.Storage.constants.EXPIRES_1YEAR, function (err) {
              err && log.error('failed to persist receiver toaster state', err);
            });
            dialog.close();
            args && args.onDismiss && args.onDismiss();
          }
        }, {
          title: 'Välj favoriter',
          callback: function callback() {
            location.href = svs.utils.urlMapping.get('grassrootsHome');
            args && args.onSuccess && args.onSuccess();
          }
        }]
      });
      svs.components.dialog.api.add(dialog); 
    } else {
      args && args.onDismiss && args.onDismiss();
    }
  };

  return {
    show: show
  };
};
 })(window);